import { Category } from '@src/types/graphql-types'
import useFormikHelper from '../../useFormikHelper'
import useTubeValidation from '../../useTubeValidation'
import {
  FormControlLabel,
  Grid,
  RadioGroup,
  Typography,
} from '@material-ui/core'
import StyledRadio from '@src/routes/Configurators/utils/ConfiguratorCustomRadioButton'
import messages from '../../../../messages'
import { FormattedMessage } from 'react-intl'
import { ModificationTypes, ModificationValues } from '../../enum'
import { splitMessages } from '../../utils'
import ValidationErrors from '@src/routes/Configurators/validations/ValidationErrors'
import FeasibilityMessage from './FeasibilityMessage'
import { baseLengthValue } from '../../ProductsConfiguration'

interface FiveReporterAndThreeQuencherType {
  disabled: boolean
  modificationType: string
  modData?: Category
  maxBaseLength: number
}

const FiveReporterAndThreeQuencher: React.FC<
  FiveReporterAndThreeQuencherType
> = ({ disabled, modificationType, modData, maxBaseLength }) => {
  const formik = useFormikHelper()
  const { ThreeMod, FiveMod, InternalMod } = ModificationTypes
  const { validationAPI } = useTubeValidation()

  let defaultSelectionValue =
    formik.selectedOligoValues[modificationType] || ModificationValues.None
  if (disabled) {
    defaultSelectionValue = ''
  }
  const modificationErrorList =
    (formik.errors?.modification &&
      splitMessages(formik.errors.modification)) ||
    []

  const hasInternalMod = ['dualquench', 'internalquench'].includes(
    formik.selectedOligoValues.probeType || ''
  )
  const threeModIndex = hasInternalMod ? 2 : 1
  const internalModIndex = hasInternalMod ? 1 : -1

  const checkForDisabled = (modValue: string) => {
    const threeFiveAndInternalModValue = modValue.split('/')
    const fiveModValue = threeFiveAndInternalModValue[0]
    const threeModValue = threeFiveAndInternalModValue[threeModIndex]

    return (
      disabled ||
      (hasInternalMod &&
        (baseLengthValue(formik.selectedOligoValues.sequence) < 10 ||
          (baseLengthValue(formik.selectedOligoValues.sequence) >
            maxBaseLength &&
            !formik.selectedOligoValues?.isOverridden))) ||
      !(
        formik.selectedOligoValues.enabledFiveModifications?.includes(
          fiveModValue
        ) &&
        formik.selectedOligoValues.enabledThreeModifications?.includes(
          threeModValue
        )
      )
    )
  }
  const onModChange = (value: string) => {
    formik.setFieldError('modification', '')
    formik.setFieldValue('loading', true, false)
    const threeFiveAndInternalModValue = value.split('/')

    const fiveModValue = threeFiveAndInternalModValue[0]
    const internalModValue = threeFiveAndInternalModValue[internalModIndex]
    const threeModValue = threeFiveAndInternalModValue[threeModIndex]

    formik.setOligoFieldValue(modificationType, value, false)
    formik.setOligoFieldValue(ThreeMod, threeModValue, false)
    formik.setOligoFieldValue(FiveMod, fiveModValue, false)
    formik.setOligoFieldValue(InternalMod, internalModValue, false)
    if (internalModValue) {
      formik.setFieldTouched('sequence', true, false)
      formik.insertInternalMod(
        internalModValue,
        undefined,
        formik.selectedOligoValues?.isOverridden
      )
    } else {
      validationAPI({
        ...formik.validationFields,
        [ThreeMod]: threeModValue,
        [FiveMod]: fiveModValue,
        [InternalMod]: internalModValue,
      })
    }
  }

  return (
    <>
      <RadioGroup
        aria-label={`${modificationType}-modifications`}
        name={modificationType}
        onChange={(e) => onModChange(e.target.value)}
        value={defaultSelectionValue}
        row
      >
        <Grid container spacing={2}>
          {modData?.modifications.map((mod, index) => (
            <Grid item xs={4} key={index}>
              <FormControlLabel
                control={<StyledRadio isConfiguratorsRedesign="true" />}
                label={
                  <Typography>
                    <FormattedMessage {...messages[mod.displayName]} />
                  </Typography>
                }
                value={mod.value}
                disabled={checkForDisabled(mod.value)}
                key={mod.value}
              />
            </Grid>
          ))}
        </Grid>
      </RadioGroup>
      {!formik.allValues.loading &&
        (formik.allValues.hasTriedNextStep ||
          (formik.selectedOligoValues.threeMod &&
            formik.selectedOligoValues.threeMod !== '')) &&
        modificationErrorList.length > 0 && (
          <ValidationErrors
            errors={modificationErrorList}
            configuratorsRedesign
          />
        )}
      <FeasibilityMessage />
    </>
  )
}

export default FiveReporterAndThreeQuencher
